import { Button } from 'antd'
import React from 'react'

function HrefButton({children,href="#"}) {
  return (
    <Button href={href} className='auf-button'>{children}</Button>
  )
}

export default HrefButton